import FeatureFlags from '@/constants/FeatureFlags';
import launchDarkly from '@bambeehr/vue-launch-darkly';
import useMiddlewareContext from './hooks/useMiddlewareContext';

/**
 * Middleware to guard journal feature pages with H3_FLYWHEEL feature flag
 * Protects:
 * - Journal pages (/journal, /journal/:id)
 *
 * Redirects to dashboard if:
 * - H3_FLYWHEEL feature flag is not enabled
 */
export default () => {
  const { route, redirect } = useMiddlewareContext();

  const featureFlagEnabled = launchDarkly.getFlags()[FeatureFlags.H3_FLYWHEEL];

  // Only allow access if feature flag is enabled
  if (!featureFlagEnabled) {
    // If trying to access journal pages, redirect to dashboard
    if (route.path.includes('/journal')) {
      redirect('/dashboard');
    }
  }
};
